import { render, staticRenderFns } from "./addNft.vue?vue&type=template&id=09a5ef32&"
import script from "./addNft.vue?vue&type=script&lang=js&"
export * from "./addNft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports